var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showUploadWindow)?_c('div',{staticClass:"upload-window"},_vm._l((_vm.files),function(file){return _c('div',{key:file.id,staticClass:"uploading-file"},[_c('UploadingFile',{attrs:{"file":file}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }